'use strict';

var MITS = require('./mits');
/**
 * Allows us to "MITS.require" a DWR Service to be loaded on demand.
 */

var WebRemoting = {
    require: function(name) {
        MITS.include('dwr/interface/' + name + '.js', true);
    },

    loadService: function(name) {
        WebRemoting.require(name);
        return global[name];
    },

    errorHandler: function(message, exception, cleanupFunction) {

        var exceptionType = '';
        if (exception) {
            if (typeof exception.javaClassName == 'string') {
                exceptionType = exception.javaClassName + ' ';
            }
            else if (typeof exception.name == 'string') {
                exceptionType = exception.name + ' ';
            }
        }

        if (WebRemoting._isServerDown(exceptionType.trim())) {
            //On FireFox, we get that the server down when the user is actually
            //just navigating away from the page.  That's much more common than
            //the server actually being down, so we ignore the error.
            if (ie6 || ie7 || ie8) {
                alert('The web server is currently unreachable. Contact your system administrator.');
            }
        }
        else {
            console.error('There was an internal error: message=' + message, exception);
            alert('There was an internal error. Please try again.\n'+
                'If the problem persists, check the web server logs or contact support.\n\n' +
                'Error Details: ' + exceptionType + message);
        }

        if (typeof cleanupFunction == 'function') {
            cleanupFunction();
        }
    },

    _isServerDown: function(exceptionType) {
        if (exceptionType === 'NS_ERROR_NOT_AVAILABLE') {
            //Firefox gives this error when the server is down.
            //I'm not totally sure if it gives this error in other situations.
            return true;
        }

        if (exceptionType === 'dwr.engine.missingData') {
            //DWR gives this error in IE6 and IE7 when the server is down.
            return true;
        }

        return false;
    },


    /**
     * Most times, you will want the above errorHandler function to display the
     * error message, but after displaying the message, you need to close a modal
     * or turn off some "busy" indicator.  This function is syntactic sugar
     * that lets you specify your callback function and "cleanup" logic. 
     * It returns an "options" object, to be used with the remote method call.
     */
    createRemoteCallOptions: function(callbackFunction, cleanupFunction) {
        var options = {
            callback: callbackFunction,

            errorHandler: function(message, exception) {
                WebRemoting.errorHandler(message, exception, cleanupFunction);
            },

            warningHandler: function(message, exception) {
                WebRemoting.errorHandler(message, exception, cleanupFunction);
            }
        };

        return options;
    }
};

module.exports = WebRemoting;

// ---------------------------------------------
// Set the default error handlers.
// These can be overridden on a per-call basis.
// Java exceptions will trigger the error handler unless an
// exceptionHandler is provided on a call.
// ---------------------------------------------
dwr.engine.setErrorHandler(WebRemoting.errorHandler);
dwr.engine.setWarningHandler(WebRemoting.errorHandler);

// text handler specific to Discover
dwr.engine.setTextHtmlHandler(function() {
        //If we got a text page, that means the session timed out.
        disableUnsavedWarning();
        document.location = 'login.md';
    });


//////////////////
// WEBPACK FOOTER
// ./mits/WebRemoting.js
// module id = 6
// module chunks = 0